import { DnsApiClient } from '@fourthwall/services/dist/DnsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useDnsQuery = createQueryHook(DnsApiClient.getDns, {
  queryKey: ['dns'],
})
